var ENUM = {
    Filters: Object.freeze({
        ALL: "ALL",
        RECENT: "RECENT",
        LOGISTICS: "LOGISTICS",
        BTS: "BTS",
        PRIVATE: "PRIVATE",
    },
    )
};

export default ENUM;